import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { DashboardService } from '@treasury/domain/dashboard';
import { ResourceCenterItem } from '@treasury/domain/dashboard/resource-center-item.entity';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/tm-card';
import '@treasury/presentation/components/tm-icon';
import '@treasury/presentation/components/tm-loader';
import '@treasury/presentation/components/tm-tooltip';
import { css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { ResourceCenterItemVm } from '../data/resource-center-item.vm';
import './resource-center-item';

export const tagName = 'resource-center-widget';
@customElement(tagName)
export class ResourceCenterWidget extends TmBaseComponent {
    @property({ type: Boolean })
    private loading = false;

    @InjectProperty()
    declare private dashService: DashboardService;

    @state()
    private resources: ResourceCenterItemVm[] = [];

    protected async firstUpdated() {
        this.loading = true;
        try {
            const resources = (await this.dashService.getResourceCenter()) as ResourceCenterItem[];
            this.resources = resources.map(resource => new ResourceCenterItemVm(resource));
        } finally {
            this.loading = false;
        }
    }

    protected render() {
        const content = this.loading ? html`<tm-loader card></tm-loader>` : this.renderResources();

        return html`<tm-card .header=${'Resource Center'}>
            <div>${content}</div>
        </tm-card>`;
    }

    private renderResources() {
        return this.resources.length > 0
            ? this.resources.map(
                  resource =>
                      html`<resource-center-item .resource=${resource}></resource-center-item>`
              )
            : html`<p>
                  The Resources tile is a place to find links to helpful or important information
                  including websites, forms and user guides. Check back soon for Resource
                  information!
              </p>`;
    }

    public static get styles() {
        return css`
            :host {
                display: block;
                --tm-card-min-width: auto;
                --tm-card-min-height: 75px;
            }
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: ResourceCenterWidget;
    }
}
